import React from "react";
import {
  CreateActionComponent,
  CreateHeadaerComponent,
} from "../../../components/CustomListHeader/CustomListHeader";
import styles from "./Styles.module.css";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import { IconButton,Typography, MenuItem, Checkbox } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import useAdminUsersCreateHook from "./AdminUsersCreate.hook";
import { useTheme } from "@emotion/react";
import CustomSelectField from "../../../components/FormFields/SelectField/SelectField.component";
import MultiComplete from "../../../components/FormFields/AutoCompleteText/MultiComplete";
const AdminUsersCreate = () => {
  const {
    editId,
    errorData,
    changeTextData,
    form,
    onBlurHandler,
    handleSubmit,
    listData,
    togglePasswordVisibility,
    showPassword,
    showConfirmPassword,
    toggleConfirmPasswordVisibility,
    id
  } = useAdminUsersCreateHook();

  const theme = useTheme();

  return (
    <>
      <div className={styles.outerFlex1}>
        <CreateHeadaerComponent title={id ? "Edit User" : "Add User"} />
      </div>
      <ShadowBox className={styles.container}>
        <div>
          <div className={"headerFlex"}>
            <h4 className={styles.infoTitle}>
              <Typography variant={"title"} className={"heading"}>
              Personal Information
              </Typography>
            </h4>
          </div>
          <div className={styles.outerFlex}>
          

            <div className={styles.lowerWrap}>
              <div className={"formFlex"}>
                <div className={"formGroup"}>
                  <CustomTextField
                    isError={errorData?.name}
                    errorText={errorData?.name}
                    label={
                      <>
                        Full Name{" "}
                        <span style={{ color: theme.palette.error.main }}>
                          *
                        </span>
                      </>
                    }
                    value={form?.name}
                    onTextChange={(text) => {
                      changeTextData(text, "name");
                    }}
                    onBlur={() => {
                        onBlurHandler("name");
                    }}
                  />
                </div>
                <div className={"formGroup"}>
                  <CustomTextField
                    isError={errorData?.email}
                    errorText={errorData?.email}
                    label={
                      <>
                        Email ID{" "}
                        <span style={{ color: theme.palette.error.main }}>
                          *
                        </span>
                      </>
                    }
                    value={form?.email}
                    onTextChange={(text) => {
                      changeTextData(text, "email");
                    }}
                    onBlur={() => {
                        onBlurHandler("email");
                    }}
                  />
                </div>
              </div>
              <div className={styles.formFlex}>
              <div className={styles.formGroup}>
                <CustomSelectField
                  isError={errorData?.type}
                  errorText={errorData?.type}
                  label={
                    <>
                      Type{" "}
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                  value={form?.type}
                  handleChange={(value) => {
                    changeTextData(value, "type");
                  }}
                >
                  <MenuItem value={"ADMIN"}>Admin</MenuItem>
                  <MenuItem value={"CLIENT_USER"}>Client User</MenuItem>                
                </CustomSelectField>
              </div>
              <div className={styles.formGroup}>
              <MultiComplete
                  size={"small"}
                  //multiple
                  id="tags-outlined"
                  // options={AutoCompleteData ? AutoCompleteData : []}
                  AutoCompleteList={listData?.ROLES ? listData?.ROLES : []}
                  label={
                    <>
                      Role{" "}
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                  value={form?.role_id}
                  isError={errorData?.role_id}
                  errorText={errorData?.role_id}
                  onTextChange={(selectedItems) => {
                    changeTextData(selectedItems, "role_id");
                  }}
                  enableField={["label"]}
                />

              </div>
            </div>
           { !id && (
              <>
            <div className={styles.formFlex}>
              <div className={styles.formGroup}>
              <CustomTextField
                      type={showPassword ? "text" : "password"}
                      isError={errorData?.password}
                      errorText={errorData?.password}
                      label={
                      <>Password
                      <span style={{ color: theme.palette.error.main }}>*</span>
                      </>}
                      value={form?.password}
                      onTextChange={(text) => {
                        changeTextData(text, "password");
                      }}
                      onBlur={() => {
                        onBlurHandler("password");
                      }}
                      autoComplete="new-password"
                    />

                    <IconButton
                      className={styles.visibleIcon}
                      onClick={togglePasswordVisibility}
                    >
                      {!showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
              </div>
              <div className={styles.formGroup}>
              <CustomTextField
                      type={showConfirmPassword ? "text" : "password"}
                      isError={errorData?.confirm_password}
                      errorText={errorData?.confirm_password}
                      label={
                      <>Confirm Password
                      <span style={{ color: theme.palette.error.main }}>*</span>
                      </>}
                      value={form?.confirm_password}
                      onTextChange={(text) => {
                        changeTextData(text, "confirm_password");
                      }}
                      onBlur={() => {
                        onBlurHandler("confirm_password");
                      }}
                       autoComplete="new-password"
                    />

                    <IconButton
                      className={styles.visibleIcon}
                      onClick={toggleConfirmPasswordVisibility}
                    >
                      {!showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
              </div>
            </div>
            </>
           )}
              <div className={"formFlex"}>
                <div className={"formGroup"}>
                <MultiComplete
                  size={"small"}
                  multiple={form?.type === "ADMIN"}
                  id="tags-outlined"                 
                  AutoCompleteList={listData?.CLIENTS ? listData?.CLIENTS : []}
                  label={
                    <>
                      Select Client{" "}
                      {form?.type==="CLIENT_USER" && (<span style={{ color: theme.palette.error.main }}>*</span>)}
                    </>
                  }
                  value={form?.client_ids}
                  isError={errorData?.client_ids}
                  errorText={errorData?.client_ids}
                  onTextChange={(selectedItems) => {
                    changeTextData(selectedItems, "client_ids");
                  }}
                  enableField={["label"]}
                />
                </div>
              </div>
              {form?.type==="CLIENT_USER" && (
              <div className={"formFlex"}>
                <div className={"formGroup"}>
                <MultiComplete
                  size={"small"}
                  multiple
                  id="tags-outlined"

                  AutoCompleteList={listData?.PROGRAMS ? listData?.PROGRAMS : []}
                  label={
                    <>
                      Select Program{" "}
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                  value={form?.program_ids}
                  isError={errorData?.program_ids}
                  errorText={errorData?.program_ids}
                  disabled={!form?.client_ids?.id }            
                  onTextChange={(selectedItems) => {
                    changeTextData(selectedItems, "program_ids");
                  }}
                  enableField={["label"]}
                />
                </div>
              </div>
              )}
              <div className={styles.formFlex}>
              <div className={styles.formGroup}>
                <div className={styles.checkWrap}>
                  <Checkbox
                    size="small"
                    style={{ padding: "0" }}
                    name={"is_approver"}
                    checked={form.is_approver}
                    onChange={() =>
                      changeTextData(!form?.is_approver, "is_approver")
                    }
                  />
                  <Typography variant="body1" sx={{ ml: "5px" }}>
                  Is Approver
                  </Typography>
                </div>
              </div>
            </div>

             
            </div>
          </div>
        </div>
      </ShadowBox>

      <div className={styles.saveButton}>
        <CreateActionComponent
          handleSubmit={handleSubmit}
          isRemove={false}
          // isSubmitting={isSubmitting}
          title={id ? "SAVE" : "CREATE"}
        />
      </div>
    </>
  );
};

export default AdminUsersCreate;
